// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
import 'element-ui/lib/theme-chalk/index.css';
import promise from 'es6-promise';
promise.polyfill();
import axios from 'axios';
import Qs from 'qs';
import Common from './js/common.js';
import quillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {downloadFile} from './js/download.js'
import VueClipboard from 'vue-clipboard2'
import * as filters from './filters' // global filters


import './style/style.css'
import JsonViewer from 'vue-json-viewer'
import ElementUI from 'element-ui';

Vue.use(JsonViewer)

Vue.config.productionTip = false

const host = process.env.NODE_ENV === 'production' ? '' : '/'
const instance = axios.create({
	baseURL: host
})

Vue.prototype.$http = instance
Vue.prototype.axios = axios;
Vue.prototype.qs = Qs;
Vue.prototype.download = downloadFile
Vue.use(VueRouter)
Vue.use(ElementUI, {
  size: 'small', // set element-ui default size
})
Vue.use(elTableInfiniteScroll);
Vue.use(Vuex)
Vue.use(Common)
Vue.use(quillEditor)
Vue.use(VueClipboard)

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

//cv以下代码解决路由地址重复的报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const store = new Vuex.Store({
	state: {
    token: '476a63883a8be623ea0caeffdec81c62a09a232245bfe3d9c2f15e03ce1a5',//请求caps系统接口密钥
    highestAuthorityAdmin: "bruce",
    fromLogin: false,
    adminInfo: '',//登陆人员信息
    btnPermited: false,//增删改权限
    menu: [],
    allPrincipals: [] ,//可选择的负责人
    principalMainRouterId: '' //负责人新增主权限菜单ID
  },
  actions: {

  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js